<!-- 个人支出 -->
<template>
  <div class="panel" style="height:100%;">
    <div class="panel-title">
      <span>个人支出</span>
      <p style="position: relative; left: 20px; display: inline; font-size: small;">
        <a-select v-model="year" placeholder="请选择所属财年" @change="yearChange" style="width: 100px;">
          <a-select-option v-for="(item, index) in yearList" :key="index" :value="item">{{ item }}</a-select-option>
        </a-select>
      </p>
    </div>
    <a-row v-for="(item, index) in personalTotalList" :key="index">
      <a-col v-for="item1 in item" :span="6" class="readNewspaper" :key="item1.id">
        <div class="ico" :style="{backgroundColor: item1.color}">
          <a-tooltip placement="topLeft">
            <template slot="title">{{ item1.formula || item1.name }}</template>
            <a-icon :type="item1.icon" style="font-size: 20px;" />
          </a-tooltip>
        </div>
        <div class="value">
          <a-tooltip placement="topLeft">
            <template
              slot="title"
            >{{ parseFloat(item1.num || 0).toLocaleString('zh-CN', {minimumFractionDigits: 2, maximumFractionDigits: 2})}}</template>
            <span>{{ bigNumberTransform(item1.value) }}</span>
          </a-tooltip>
          <span v-html="item1.name" />
        </div>
      </a-col>
    </a-row>
  </div>
</template>

<script>
import moment from 'moment'
import db from '@/utils/localstorage'
import { FormatTime } from '@/utils/timer'
import { mapState } from 'vuex'
export default {
  computed: {
    ...mapState({
      permissions: state => state.account.permissions
    }),
    yearList () {
      const year = new Date().getFullYear()
      const arr = []
      for (let i = 0; i < 10; i++) {
        arr.push((year - i) + '年')
      }
      return arr
    }
  },
  beforeMount () {
    // 默认查询当前年
    let timeArr = [moment().startOf('year'), moment().endOf('year')]
    let time = {}
    time.startDate = FormatTime(timeArr[0], 'YYYY-MM-DD')
    time.endDate = FormatTime(timeArr[1], 'YYYY-MM-DD')
    this.getData(time)
  },
  data () {
    return {
      year: new Date().getFullYear(),
      dbUserRoleIdList: db.get('USER').roleId.split(','),
      count: 0,
      personalTotalList: [
        [
          {
            id: 1,
            value: 0,
            num: 0,
            name: '支出总计',
            color: '#42b983',
            icon: 'user'
          },
          {
            id: 2,
            value: 0,
            num: 0,
            name: '人员成本',
            color: '#0089fe',
            icon: 'team'
          },
          {
            id: 3,
            value: 0,
            num: 0,
            name: '费用报销',
            color: '#0089fe',
            icon: 'euro'
          },
          {
            id: 4,
            value: 0,
            num: 0,
            name: '现金支付',
            color: '#52c41a',
            icon: 'pay-circle'
          }
        ]
      ]
    }
  },
  methods: {
    moment,
    yearChange (e) { // 财年选择
      let timeArr = [moment(e, 'YYYY').startOf('year'), moment(e, 'YYYY').endOf('year')]
      let time = {}
      time.startDate = FormatTime(timeArr[0], 'YYYY-MM-DD')
      time.endDate = FormatTime(timeArr[1], 'YYYY-MM-DD')
      this.getData(time)
    },
    getData (time) {
      this.$get('/home/countBoardForPerson', time).then(res => {
        if (res.data.status === 1) {
          let data = res.data.data
          this.personalTotalList[0][0].value = this.personalTotalList[0][0].num = data.humanCost + data.personalCost + data.festivalGiftMoney
          this.personalTotalList[0][1].value = this.personalTotalList[0][1].num = data.humanCost
          this.personalTotalList[0][2].value = this.personalTotalList[0][2].num = data.personalCost
          this.personalTotalList[0][3].value = this.personalTotalList[0][3].num = data.festivalGiftMoney
        } else {
          this.$message.warning(res.data.message)
        }
      })
    },
    bigNumberTransform (value) {
      if (value) {
        let param = ''
        let k = 10000
        if (value < k) {
          if (value < -10000) {
            if (value < -100000000) {
              let yiyuan = (value / 100000000).toFixed(2)
              return yiyuan + '亿'
            } else {
              let fsy = (value / 10000).toFixed(2)
              return fsy + '万'
            }
          } else {
            param = value.toFixed(2)
            return param + '元'
          }
        } else {
          let sizes = ['', '万', '亿', '万亿']
          let i
          i = Math.floor(Math.log(value) / Math.log(k))
          param = `${((value / Math.pow(k, i))).toFixed(2)}${sizes[i]}`
          return param
        }
      } else {
        return value || 0 + '元'
      }
    }
  }
}
</script>

<style lang="less" scoped>
.value-first {
  font-size: 22px !important;
  font-weight: bold !important;
  color: #000 !important;
}
.panel {
  padding-bottom: 0.6rem;
  background-color: #fff;
  border: 1px solid transparent;
  border-radius: 10px;

  .panel-title {
    width: 100%;
    border-bottom: solid 1px #e9e9e9;
    line-height: 50px;
    padding-left: 15px;
    position: relative;

    &::before {
      content: '';
      display: inline-block;
      width: 4px;
      height: 30px;
      background-color: #0079fe;
      position: absolute;
      left: 0;
      top: 10px;
      border-radius: 4px;
    }

    span {
      &:first-child {
        font-size: 18px !important;
        font-weight: 400;
      }
    }
  }

  .readNewspaper {
    display: flex;
    position: relative;
    // margin: 30px 0px 30px 0px;
    margin: 3% 0;
    padding-left: 30px;
    padding-right: 0px;

    .ico {
      display: inline-block;
      background-color: #0089fe;
      border-radius: 38%;
      width: 50px;
      height: 50px;
      line-height: 50px;
      color: #ffffff;
      text-align: center;
      font-size: 20px;
      // position: relative;
      // top: 6px;
      /deep/ svg {
        font-size: 20px !important;
      }
    }

    .value {
      margin-left: 0.6rem;
      display: flex;
      flex-direction: column;
      justify-content: space-between;

      span {
        font-size: 14px;
        color: #797979;

        &:first-child {
          font-size: 22px !important;
          color: #333333;
        }
      }
    }
  }

  .noticeList {
    padding: 16px 15px;

    .notice {
      display: flex;
      cursor: pointer;
      justify-content: space-between;

      .notice-title {
        font-size: 14px;
        color: #333333;
        margin-bottom: 5px;
      }

      .notice-content {
        font-size: 12px;
        color: #797979;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/homeComponents/personalOutlays.vue